import { render, staticRenderFns } from "./account-update.vue?vue&type=template&id=35af9a17"
import script from "./account-update.vue?vue&type=script&lang=js"
export * from "./account-update.vue?vue&type=script&lang=js"
import style0 from "./account-update.vue?vue&type=style&index=0&id=35af9a17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports